import { type RouteObject } from 'react-router'

import { Bootstrap } from './Bootstrap'
import { appRegistry } from './registry'

/**
 * Every app's customer-less entry path (`/arc`, `/scout`), as routes to nest at the router's root:
 * each resolves a customer and redirects into that app beneath `/c/:customer/`.
 *
 * They carry no customer, so `/c/` stays the sole marker of a customer segment (Atlas ADR-0001), and an
 * app id can never be read as a customer id. Declared *after* the shell's own root routes in
 * `routes.tsx`, which is what keeps an app id from shadowing one: react-router breaks a tie between
 * equal-ranked literal routes by declaration order.
 *
 * The whole registry rather than `getEnabledApps()`, matching `mountedAppRoutes`: the shared
 * resolution chain decides whether a named app is available and falls back when it is not.
 *
 * Beside `registry.ts` rather than in it because this file carries JSX and that one must stay `.ts`:
 * the lint rule letting the shell import an app is scoped to that path exactly, so renaming it would
 * silently drop the suite's app-agnostic boundary rule.
 */
export const appEntryRoutes = (): RouteObject[] =>
  appRegistry.map((app) => ({
    path: app.id,
    element: <Bootstrap appId={app.id} />,
  }))
